import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import de_common from "src/locales/de/common.json"
import de_default from "src/locales/de/default.json"
import en_common from "src/locales/en/common.json"
import en_default from "src/locales/en/default.json"
import ja_common from "src/locales/ja/common.json"
import ja_default from "src/locales/ja/default.json"

import { Namespaces } from "./hooks/use-translate"
import { locale } from "./utilities/constants"

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: { [Namespaces.Default]: en_default, [Namespaces.Common]: en_common },
      de: { [Namespaces.Default]: de_default, [Namespaces.Common]: de_common },
      ja: { [Namespaces.Default]: ja_default, [Namespaces.Common]: ja_common },
    },
    defaultNS: "default",
    lng: locale,
    fallbackLng: "en",
    ns: [Namespaces.Default, Namespaces.Common],

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  })
